/**
 * Created by Rodrigo Quesada on 28/12/16.
 */
import {NgModule, ModuleWithProviders} from '@angular/core';
import {Routes} from '@angular/router';
import {SECTION_ROUTES, SectionsService} from './service/sections.service';
import {NavigableNodeDeps} from './service/navigable-node.class';
import {ScreensManagerDeps} from './service/screen-manager.class';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [SectionsService, NavigableNodeDeps, ScreensManagerDeps],
})
export class SectionsModule {

    static forRoot(routes: Routes): ModuleWithProviders {
        return {
            ngModule: SectionsModule,
            providers: [{provide: SECTION_ROUTES, useValue: routes}]
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/sections/sections.module.ts